import React from 'react';

import { MobileAppBanner } from '../../../mobile/components/MobileAppBanner';
import { ProcessAndRemoveSamlQueryWrapper } from '../../../spacesPlatform/routerHelpers/saml/ProcessAndRemoveSamlQueryWrapper';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';
import { LoginPageStrategy } from './LoginPageStrategy';

export interface SignInProviderProps {
  readonly routeLocationSearch: string;
}

export class SignInProvider extends React.Component<SignInProviderProps> {
  public render() {
    return (
      <DefaultServerTitleWrapper>
        <ProcessAndRemoveSamlQueryWrapper>
          <div>
            <MobileAppBanner />
          </div>
          <div>
            <LoginPageStrategy {...this.props} />
          </div>
        </ProcessAndRemoveSamlQueryWrapper>
      </DefaultServerTitleWrapper>
    );
  }
}
